<template>
  <div class="web_index">
    <BaseHeader></BaseHeader>

    <div style="width: 100%;height: 80px"></div>
    <div class="web_content">
      <div class="cooperate_content">
        <span>“Vista看天下”合作品牌(注：排名不分先后)</span>
      </div>

      <img class="cooperate_img" src="../../assets/png/ktx_c.png"  style="width: 1180px;height: auto" >

      <div class="cooperate_content" style="margin-top: 20px;">
        <span>“Vista氢商业”合作品牌(注：排名不分先后)</span>
      </div>

      <img class="cooperate_img" style="width: 530px;height: auto;margin-top: 40px;margin-left: 10px;" src="../../assets/png/qys_c.png" width="530" >

      <div class="cooperate_content" style="margin-top: 40px">
        <span>商务合作方式</span>
      </div>
      <div class="content">
        <p>商务合作联系方式：QQ:2798493263</p>
      </div>

    </div>

    <component v-bind:is="'BaseBottom'"></component>
  </div>
</template>

<script>
    import BaseBottom from './BaseBottom.vue'
    import BaseHeader from './BaseHeader.vue'
  import router from '../../router'
export default {
  name: 'Index',
    components: {BaseBottom: BaseBottom,BaseHeader},
  data () {
    return {
      jumpType:3
    }
  },
  methods: {

  },
  mounted :function() {
    // this.jumpType = this.$router.query.jumpType
  },
    updated(){

    }
}
</script>


<style scoped="page">
  .web_index{
    width: 100%;
    background-color: #F0F4F5;
  }
  .web_title{
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 1000;
  }
  .web_title_content{
    width: 1290px;
    height: 80px;
    margin: auto;
    position: relative;
  }
  .title_img{
    margin-left: 40px;
    margin-top: 18px;
  }
  .title_content{
    height: 80px;
    position: absolute;
    right:45px;
    top: 0;
  }
  .title{
    float: right;
    height: 80px;
    line-height: 80px;
    font-size: 18px;
  }
  .title_red{
    float: right;
    height: 70px;
    line-height: 80px;
    font-size: 18px;
    border-bottom: 2px solid #cd001b;
    color: #000000;
  }
  .web_content{
    width: 1200px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-top: 60px;
    padding-bottom: 100px;
    background-color: #ffffff;
  }
  .cooperate_content{
    margin-left: 30px;
    font-size: 24px;
    color: #000000;
  }
  .cooperate_img{
    width: 1174px;
    height: 341px;
    margin-top: 20px;
    margin-left: 3px;
  }
  .content{
    margin-left: 30px;
    margin-top: 40px;
    font-size: 16px;
    color: #323232;
  }

  .web_bottem{
    background-color: #2E3139;
    width: 100%;
    height: 120px;
    font-size: 16px;
    color: #C4C4C4;
    line-height: 120px;
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/web/Cooperation.vue